import styled from 'styled-components';

export const ActionButtons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
`;
